import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { logout } from "../services/authService";
import "../styles/Navbar.css";

export const NavbarToggle = ({ onToggle }) => {
  return (
    <span className="sidebar-toggle d-flex mr-2" onClick={onToggle}>
      <i className="hamburger align-self-center" />
    </span>
  );
};

export const NavbarDropdowns = ({ isDashboard = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const navBarClass = isDashboard
    ? "effekt-dashboard-navbar navbar-theme navbar navbar-expand"
    : "effekt-navbar navbar-theme navbar navbar-expand";

  return (
    <div className={navBarClass} ref={dropdownRef}>
      <div className="navbar-nav">
        <div className={`nav-item dropdown ${isOpen ? "show" : ""}`}>
          <button
            className="nav-link dropdown-toggle"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span>⚙️</span>
          </button>
          <div className={`dropdown-menu dropdown-menu-right ${isOpen ? "show" : ""}`}>
            <button className="dropdown-item" type="button" onClick={(e) => e.preventDefault()}>
              <span className="mr-2">🔑</span>
              Change Password
            </button>
            <div className="dropdown-divider"></div>
            <button 
              className="dropdown-item" 
              type="button" 
              onClick={async (e) => {
                e.preventDefault();
                try {
                  await logout();
                  history.push('/login');
                } catch (error) {
                  console.error('Logout error:', error);
                  // Still redirect to login even if logout fails
                  history.push('/login');
                }
              }}
            >
              <span className="mr-2">🚪</span>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const NavbarComponent = ({ onToggle }) => {
  return (
    <nav className="navbar navbar-expand navbar-theme">
      <NavbarToggle onToggle={onToggle} />
    </nav>
  );
};

/**
 * Logout Button Component
 * A visible logout button that can be placed in the header
 */
export const LogoutButton = () => {
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await logout();
      history.push('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Still redirect to login even if logout fails
      history.push('/login');
    }
  };

  return (
    <button 
      className="logout-button" 
      onClick={handleLogout}
      title="Logout"
    >
      <span className="logout-icon">🚪</span>
      <span className="logout-text">Logout</span>
    </button>
  );
};

export default NavbarComponent;

